import {
  ControlledDeviceSettingValue,
  DesiredSettingValue,
} from '@crossnokaye/typescript-sdk/models/components';

import { SettingAction, SettingActionValueKind } from '@repo/sdk/models/components';

import { castSettingsValue, getDesiredSettingValueKind } from '@/helpers/settings';

export const makeControlledDeviceSettingValue = (
  settingAction: SettingAction
): ControlledDeviceSettingValue => {
  switch (settingAction.valueKind) {
    case SettingActionValueKind.Number:
      return {
        number: castSettingsValue(settingAction.numberValue, SettingActionValueKind.Number),
      };
    case SettingActionValueKind.Boolean:
      return {
        boolean: castSettingsValue(settingAction.booleanValue, SettingActionValueKind.Boolean),
      };
    case SettingActionValueKind.Enum:
      return { enum: castSettingsValue(settingAction.enumValue, SettingActionValueKind.Enum) };
    case SettingActionValueKind.Schedule:
      return {
        schedule: castSettingsValue(settingAction.scheduleValue, SettingActionValueKind.Schedule),
      };
    case SettingActionValueKind.Sequence:
      return {
        sequence: castSettingsValue(settingAction.sequenceValue, SettingActionValueKind.Sequence),
      };
    default:
      return { enum: castSettingsValue(settingAction.enumValue, SettingActionValueKind.Enum) };
  }
};

export const createDesiredSettingValues = (
  settingActions?: SettingAction[]
): DesiredSettingValue[] => {
  return (settingActions || []).map((settingAction: SettingAction) => {
    return {
      settingId: settingAction.id,
      kind: getDesiredSettingValueKind(settingAction.valueKind as SettingActionValueKind),
      desiredValue: makeControlledDeviceSettingValue(settingAction),
    };
  });
};
